import { Component, Input, HostBinding, OnInit } from '@angular/core';
import { BaseDirective } from '../../../base.directive';
import { UX_COLORS } from '@eui/core';
import { hexToCSSFilter } from 'hex-to-css-filter';

@Component({
    selector: 'span[euiIconSvg], i[euiIconSvg], eui-icon-svg',
    template: `
        <img src="assets/images/ionicons/{{icon}}.svg"
             [alt]="icon + ' icon'"
             [ngStyle]="styles"
        >
    `,
    styleUrls: ['./styles/_index.scss'],
})
export class EuiIconSvgComponent extends BaseDirective implements OnInit {
    @Input() icon: string;
    @Input() width = 18;
    @Input() color: string = 'default';

    styles = {};

    @HostBinding('class')
    public get cssClasses(): any {
        return this.getCssClasses();
    }

    constructor() {
        super();
    }

    getCssClasses() {
        return [
            super.getCssClasses('eui-icon-svg'),
        ].join(' ').trim();
    }

    ngOnInit() {
        this.styles['width.px'] = this.width;

        if (this.color) {
            const cssFilter = hexToCSSFilter(UX_COLORS[this.color]);
            this.styles['filter'] = cssFilter.filter.slice(0, -1);
        }
    }
}
